import { render, staticRenderFns } from "./ImportNewFormFrProject.vue?vue&type=template&id=12972bb2&"
import script from "./ImportNewFormFrProject.vue?vue&type=script&lang=js&"
export * from "./ImportNewFormFrProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports